export default "__VITE_ASSET__BagPPH$P__"